import React from 'react';

import ComponentsConfigContext, {
  TComponentsConfigValues
} from '../../store/context/ComponentsConfigContext';

type Props = {
  params?: TComponentsConfigValues;
};

const ComponentsConfigProvider: Component<Props> = ({
  children,
  params = {}
}) => (
  <ComponentsConfigContext.Provider value={params}>
    {children}
  </ComponentsConfigContext.Provider>
);

export default ComponentsConfigProvider;
